const ClosureNotice = () => {
  return (
    <div className="min-h-screen w-full bg-neutral-50 flex items-center justify-center px-6 text-center">
      <div className="max-w-2xl space-y-4">
        <h1 className="text-3xl font-semibold text-gray-900">Notice of Company Closure</h1>
        <p className="text-lg text-gray-700 leading-relaxed">
          We regret to inform you that ODT, Inc. (On-Demand Trading) has ceased operations effective January 30, 2026.
          This decision follows extensive evaluation of current market conditions and ongoing business challenges.
          Despite our best efforts, continuing operations was no longer sustainable.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed">
          For any questions regarding this notice, please contact us at{' '}
          <span className="font-semibold text-gray-900">compliance@ondemandtrading.com</span>
        </p>
      </div>
    </div>
  );
};

export default ClosureNotice;
